// Choose an object type before searching Work's related records.
(function () {
    function selectedKind(picker) {
        var selected = picker.querySelector('[data-related-kind]:checked');
        return selected && !selected.disabled ? selected.value : '';
    }

    function sync(picker) {
        var kind = selectedKind(picker);
        var search = picker.querySelector('[data-related-search]');
        var input = picker.querySelector('[data-related-query]');
        var prompt = picker.querySelector('[data-related-search-prompt]');
        search.hidden = !kind || kind === 'none';
        input.disabled = search.hidden;
        if (prompt) prompt.hidden = !!kind;
        var url = new URL(picker.dataset.searchUrl, location.href);
        url.searchParams.set('kind', kind);
        picker.querySelector('.typeahead').setAttribute('data-typeahead-url', url.pathname + url.search);
    }

    function clearSelection(picker) {
        // Detached results from an earlier search cannot enter the new type's menu.
        var old = picker.querySelector('.typeahead');
        var fresh = old.cloneNode(true);
        fresh.querySelectorAll('input').forEach(function (input) {
            input.value = '';
            input.defaultValue = '';
        });
        fresh.querySelectorAll('.typeahead-clear-btn').forEach(function (btn) { btn.style.display = 'none'; });
        var results = fresh.querySelector('.typeahead-results');
        results.replaceChildren();
        results.classList.remove('show');
        old.replaceWith(fresh);
    }

    document.addEventListener('change', function (event) {
        if (!event.target.matches('[data-related-kind]')) return;
        var picker = event.target.closest('[data-work-related-picker]');
        if (!picker) return;
        clearSelection(picker);
        sync(picker);
    });

    document.addEventListener('input', function (event) {
        if (!event.target.matches('[data-related-query]')) return;
        var picker = event.target.closest('[data-work-related-picker]');
        if (!picker) return;
        picker.querySelector('[data-related-token]').value = '';
        picker.querySelector('[data-related-label]').value = '';
    });

    document.addEventListener('work:related-configure', function (event) {
        var picker = event.target.closest('[data-work-related-picker]');
        if (!picker) return;
        var cleared = false;
        picker.querySelectorAll('[data-related-choice]').forEach(function (choice) {
            var kind = choice.dataset.relatedChoice;
            var allowed = (kind !== 'project' || event.detail.allowProject !== false) &&
                (kind !== 'none' || event.detail.allowNone !== false);
            choice.hidden = !allowed;
            var radio = choice.querySelector('[data-related-kind]');
            radio.disabled = !allowed;
            if (!allowed && radio.checked) {
                radio.checked = false;
                cleared = true;
            }
        });
        if (cleared) clearSelection(picker);
        sync(picker);
    });

    function init(root) {
        if (root.matches && root.matches('[data-work-related-picker]')) sync(root);
        if (root.querySelectorAll) root.querySelectorAll('[data-work-related-picker]').forEach(sync);
    }
    document.body.addEventListener('htmx:load', function (event) { init(event.target); });
    document.addEventListener('sheet:ready', function () { init(document); });
})();
